import React from "react";
import { Award, Truck, Users, Building2 } from "lucide-react";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <div>
      <Seo title="Hakkımızda" path="/hakkimizda"
           description="Kuzey Yapı Hırdavat - Zonguldak/Çaycuma'dan tüm Türkiye'ye profesyonel hırdavat ve inşaat malzemeleri tedariki."/>
      <section className="bg-ink-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img src="https://images.pexels.com/photos/37556455/pexels-photo-37556455.jpeg?w=1600" alt="" className="w-full h-full object-cover"/>
          <div className="absolute inset-0 bg-gradient-to-r from-ink-900 to-ink-900/40"></div>
        </div>
        <div className="kz-container relative py-20">
          <div className="text-xs font-bold tracking-[0.2em] text-brand mb-4">HAKKIMIZDA</div>
          <h1 className="font-display text-4xl md:text-6xl font-black leading-tight max-w-3xl">1998'DEN BERİ <span className="text-brand">USTAYLA</span> AYNI SAHADA.</h1>
        </div>
      </section>

      <section className="kz-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="font-display text-3xl font-black mb-4">Hikayemiz</h2>
            <p className="text-ink-700 leading-relaxed mb-4">Kuzey Yapı Hırdavat olarak 1998 yılında İstanbul'da küçük bir mağaza ile başladığımız yolculuğumuzu, bugün Türkiye'nin önde gelen profesyonel hırdavat tedarikçilerinden biri olarak sürdürüyoruz.</p>
            <p className="text-ink-700 leading-relaxed mb-4">Bosch, Makita, DeWalt, Stanley gibi global markaların orijinal distribütörü olarak; ustalar, inşaat firmaları ve son kullanıcılar için 10.000'den fazla ürünü tek çatı altında topluyoruz.</p>
            <p className="text-ink-700 leading-relaxed">Misyonumuz; sahada kaliteli iş üretmek isteyen herkese, doğru aleti doğru fiyatla, doğru zamanda ulaştırmak.</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { id: "exp", Icon: Building2, n: "25+", t: "Yıllık Tecrübe" },
              { id: "dealers", Icon: Users, n: "5.000+", t: "Bayi Ağı" },
              { id: "products", Icon: Award, n: "10.000+", t: "Ürün Çeşidi" },
              { id: "cities", Icon: Truck, n: "81", t: "İl Teslimat" },
            ].map((s) => (
              <div key={s.id} className="kz-card p-6 text-center">
                <s.Icon className="text-brand mx-auto mb-2"/>
                <div className="font-display font-black text-3xl">{s.n}</div>
                <div className="text-xs uppercase tracking-wider text-ink-500">{s.t}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
